<template>
    <div style="padding-bottom: 90px;" id="contenddash">
        <nav class="navbar navbar-dark " style="padding-right: 30px; padding-left: 30px;">

            <i style="font-size: 20px;" @click.prevent="mtdvoltames()" class="bi bi-chevron-left"></i>
            <h6>{{ mesatual }}</h6>
            <i style="font-size: 20px;" @click.prevent="mtdavancames()" class="bi bi-chevron-right"></i>
        </nav>


        <div class="col-12" style="margin-top: 10px;">
            <div class="row">
                <div style="padding: 30px;" class="col-md-12">
                    <div class="row">
                        <button @click.prevent="mtdMostrarEsconderFiltro()"
                            :class="!mostrafiltro ? 'btn primary' : 'btn info'" type="button">
                            <span>Filtros</span>
                            <span><i
                                    :class="!mostrafiltro ? 'bi bi-chevron-double-down' : 'bi bi-chevron-double-up'"></i></span>
                        </button>
                    </div>
                    <div v-show="mostrafiltro" class="row">
                        <div class="col-12">
                            <span class="lblselect2">Categoria:</span>
                            <select id="cbcategpesq" data-placeholder="Selecione uma categoria" v-model="vidcateg"
                                data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div class="col-12">
                            <span class="lblselect2">Conta:</span>
                            <select id="cbcontapesq" data-placeholder="Selecione uma conta" v-model="vidconta"
                                data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div class="col-12">
                            <span class="lblselect2">Objetivo/meta:</span>
                            <select id="cbmetapesq" data-placeholder="Selecione uma objetivo/meta" v-model="vidmeta"
                                data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div style="padding: 30px;" class="col-md-12">
                    <table class="table table-sm">
                        <thead>
                            <tr>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(resultado, index) in lstlancamento" :key="index">
                                <td style="font-size: x-small;">{{ resultado.nome }}</td>
                                <td class="text-center" style="font-size: 10px;">
                                    <i :class="resultado.icone" style="margin-right: 5px;"></i>
                                    {{ resultado.dtlancamento.slice(0, -9) }}
                                </td>
                                <td class="text-right" style="font-size: x-small; text-align: right;"
                                    :style="{ color: resultado.tipo == 1 ? 'darkcyan' : 'brown' }">
                                    {{ mtdformatavalordecimal(resultado.valor, 'R$') }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import util from '../util.js';
// import globals from '../globals.js';
import GraficoPie from '../graficos/graficodoughnut.vue';
export default {
    name: 'dash',
    data: function () {
        const hoje = new Date();
        return {
            mesatual: this.getNomeMes(hoje),  // Formata o mês atual para exibir no template
            peridosql: this.getPeriodoSQL(hoje), // Formata o período SQL inicial
            dataAtual: hoje, // Guarda a data atual para manipulação

            legendadespesameta: [],
            dadosdespesasmeta: [],
            mostrafiltro: false,
            //filtros
            vidcateg: null,
            vidconta: null,
            vidmmeta: null,


            lstlancamento: [],
        };
    },
    components: {
        'graficopie': GraficoPie,
    },
    methods: {
        mtdMostrarEsconderFiltro() {
            if (this.mostrafiltro) {
                this.mostrafiltro = false
            } else {
                this.mostrafiltro = true
            }
        },
        mtdformatavalordecimal(valor, digitos) {
            return util.formatarvalor(valor, digitos);
        },
        mtdavancames() {
            this.dataAtual.setMonth(this.dataAtual.getMonth() + 1); // Incrementa o mês
            this.atualizaMesPeriodo();
        },
        // Retrocede para o mês anterior
        mtdvoltames() {
            this.dataAtual.setMonth(this.dataAtual.getMonth() - 1); // Decrementa o mês
            this.atualizaMesPeriodo();
        },
        // Atualiza o mês e o período SQL
        atualizaMesPeriodo() {
            this.mesatual = this.getNomeMes(this.dataAtual);
            this.peridosql = this.getPeriodoSQL(this.dataAtual);



            this.mtdexecutadash();
        },
        // Retorna o nome do mês com o ano
        getNomeMes(data) {
            const nomeMeses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
                "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
            return `${nomeMeses[data.getMonth()]} ${data.getFullYear()}`;
        },
        // Retorna o período SQL de acordo com o mês e ano da data
        getPeriodoSQL(data) {

            //verifica se a data que selecionei está no futuro
            let new_hj = new Date();
            let legdata = data;

            if (legdata > new_hj) {
                this.futuro = true
            } else {
                this.futuro = false
            }


            const ano = data.getFullYear();
            const mes = String(data.getMonth() + 1).padStart(2, '0'); // Formata o mês com dois dígitos
            const ultimoDia = new Date(ano, data.getMonth() + 1, 0).getDate(); // Último dia do mês
            return `'${ano}-${mes}-01 00:00:00' and '${ano}-${mes}-${ultimoDia} 23:59:59'`;
        },
        mtdexecutadash() {
            let vself = this;

            let filtro = '';

            if (this.vidmeta) {
                filtro = filtro + ' and l.idmeta=' + this.vidmmeta;
            }
            if (this.vidcateg) {
                filtro = filtro + ' and l.idcategoria=' + this.vidcateg;
            }
            if (this.vidconta) {
                filtro = filtro + ' and l.idconta=' + this.vidconta;
            }

            let parametros = [
                { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
                { parametro: 'op', valor: 'reldemontrativolanto' },
                { parametro: 'periodo', valor: vself.peridosql },
                { parametro: 'filtro', valor: filtro },
                { parametro: 'previsao', valor: vself.futuro ? 1 : 0 }
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/relatorio.php');
            retorno.then(function (response) {
                vself.lstlancamento = response.data.lstlancamento;

            }).catch(function (response) {

            });

        },
    },
    mounted() {
        let vself = this
        vself.mtdexecutadash();


        $("#cbcategpesq").select2({
            id: function (e) { return e.codfil },
            ajax: {
                url: util.servidor + '/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        sqlini: 'select id, nome from tbcategorias ',
                        sqlfim: 'where upper(nome) like upper("%@@%")  and idusuario =' + localStorage.getItem('iduser'),
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidcateg = $("#cbcategpesq").val();
            if (vself.vidcateg) {
                vself.mtdexecutadash();
            }
        });


        $("#cbcontapesq").select2({
            id: function (e) { return e.codfil },
            ajax: {
                url: util.servidor + '/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        sqlini: 'select id, descricao from tbcontas ',
                        sqlfim: 'where upper(descricao) like upper("%@@%")  and idusuario =' + localStorage.getItem('iduser'),
                        cpid: 'id',
                        cpdesc: 'descricao'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidconta = $("#cbcontapesq").val();
            if (vself.vidconta) {
                vself.mtdexecutadash();
            }
        });

        $("#cbmetapesq").select2({
            id: function (e) { return e.codfil },
            ajax: {
                url: util.servidor + '/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        sqlini: 'select id, descricao from tbmetas ',
                        sqlfim: 'where upper(descricao) like upper("%@@%")  and idusuario =' + localStorage.getItem('iduser'),
                        cpid: 'id',
                        cpdesc: 'descricao'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidmeta = $("#cbmetapesq").val();
            if (vself.vidmeta) {
                vself.mtdexecutadash();
            }
        });

    }
}
</script>

<style>
.bdt {
    width: 100px !important;
    border-radius: 23px !important;
}
</style>